import styled from 'styled-components';

export const CartEmpty = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
`;

export const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 16px;
  opacity: 0.3;
`;

export const EmptyText = styled.p`
  font-size: 1rem;
  font-weight: 600;
`;

export const CartItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const CartItem = styled.div`
  background: white;
  border: 2px solid #f3f4f6;
  border-radius: 24px;
  padding: 16px;
  position: relative;
`;

export const ItemHeader = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
`;

export const ItemImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
  background: #f9fafb;
  flex-shrink: 0;
`;

export const ItemInfo = styled.div`
  flex: 1;
`;

export const ItemName = styled.h4`
  font-size: 0.875rem;
  font-weight: 900;
  text-transform: uppercase;
  color: #1f2937;
  margin: 0 0 4px 0;
  max-width: 80%;
`;

export const ItemPrice = styled.div`
  font-size: 0.95rem;
  font-weight: 900;
  color: var(--secondary, #d32f2f);
  margin-bottom: 8px;
`;

export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const QuantityButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 10px;
  background: #f3f4f6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.75rem;
  color: #6b7280;

  &:hover {
    background: #e5e7eb;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Quantity = styled.span`
  font-weight: 700;
  font-size: 0.95rem;
  min-width: 24px;
  text-align: center;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 8px;
  transition: all 0.2s;
  font-size: 1.1rem;

  &:hover {
    transform: scale(1.1);
    color: #dc2626;
  }
`;

export const DuplicateButton = styled.button`
  position: absolute;
  top: 12px;
  right: 48px;
  background: none;
  border: none;
  color: #3b82f6;
  cursor: pointer;
  padding: 8px;
  transition: all 0.2s;
  font-size: 1.1rem;

  &:hover {
    transform: scale(1.1);
    color: #2563eb;
  }
`;

export const ItemOptions = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
`;

export const OptionLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 700;
  color: #9ca3af;
  margin-bottom: 6px;
  text-transform: uppercase;
`;

export const OptionValue = styled.div`
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 600;
`;

export const OptionsGroup = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const OptionChip = styled.button<{ $active?: boolean }>`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid ${props => props.$active ? 'var(--primary, #f58220)' : '#e5e7eb'};
  background: ${props => props.$active ? 'var(--primary, #f58220)' : 'white'};
  color: ${props => props.$active ? 'white' : '#6b7280'};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const OptionTable = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 6px;
`;

export const OptionRow = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: ${props => props.$active ? 'rgba(245,130,32,0.06)' : 'white'};
  border: none;
  border-bottom: 1px dashed #e2e8f0;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${props => props.$active ? 'rgba(245,130,32,0.10)' : '#fafafa'};
  }

  &:active {
    transform: scale(0.99);
  }
`;

export const OptionCheckbox = styled.div<{ $active: boolean }>`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid ${props => props.$active ? 'var(--primary, #f58220)' : '#cbd5e1'};
  background: ${props => props.$active ? 'var(--primary, #f58220)' : 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
`;

export const OptionRowInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const OptionRowName = styled.div<{ $active: boolean }>`
  font-size: 0.83rem;
  font-weight: ${props => props.$active ? '700' : '500'};
  color: ${props => props.$active ? '#1f2937' : '#374151'};
  line-height: 1.3;
`;

export const OptionRowDesc = styled.div`
  font-size: 0.7rem;
  color: #9ca3af;
  margin-top: 2px;
  line-height: 1.4;
`;

export const OptionRowPrice = styled.div`
  font-size: 0.78rem;
  font-weight: 700;
  color: #10b981;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const DeliverySection = styled.div`
  margin-bottom: 24px;
`;

export const SectionTitle = styled.h3`
  font-size: 0.7rem;
  font-weight: 900;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
  text-align: center;
`;

export const DeliveryOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const DeliveryOption = styled.button<{ $active: boolean }>`
  padding: 16px 12px;
  border-radius: 16px;
  border: 2px solid ${props => props.$active ? 'var(--primary, #f58220)' : '#f3f4f6'};
  background: ${props => props.$active ? '#fffbf5' : 'white'};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items:center;
  justify-content: center;
  gap: 8px;

  &:hover {
    transform: scale(1.02);
  }
`;

export const DeliveryIcon = styled.span`
  font-size: 1.25rem;
`;

export const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

export const DeliveryLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 900;
  text-transform: uppercase;
  color: #1f2937;
`;

export const DeliveryFee = styled.span<{ $free?: boolean }>`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${props => props.$free ? '#10b981' : 'var(--secondary, #d32f2f)'};
`;

export const PickupAddressSection = styled.div`
  background: #f0fdf4;
  border: 2px solid #86efac;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
`;

export const PickupAddressTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  font-weight: 900;
  color: #166534;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const PickupAddressText = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  color: #166534;
  margin: 0;
  line-height: 1.5;
`;

export const PickupAddressWarning = styled.div`
  background: #fef3c7;
  border: 2px solid #fbbf24;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PickupAddressWarningIcon = styled.span`
  font-size: 1.5rem;
`;

export const PickupAddressWarningText = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  color: #92400e;
  margin: 0;
  line-height: 1.5;
`;

export const TotalSection = styled.div`
  background: #f9fafb;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 24px;
`;

export const TotalRow = styled.div<{ $highlight?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.$highlight ? '0' : '12px'};
  padding-top: ${props => props.$highlight ? '12px' : '0'};
  border-top: ${props => props.$highlight ? '2px solid #e5e7eb' : 'none'};
`;

export const TotalLabel = styled.span<{ $highlight?: boolean }>`
  font-size: ${props => props.$highlight ? '1.1rem' : '0.8rem'};
  font-weight: ${props => props.$highlight ? '900' : '700'};
  color: ${props => props.$highlight ? '#1f2937' : '#9ca3af'};
  text-transform: uppercase;
`;

export const TotalValue = styled.span<{ $highlight?: boolean }>`
  font-size: ${props => props.$highlight ? '1.75rem' : '0.95rem'};
  font-weight: 900;
  color: ${props => props.$highlight ? 'var(--secondary, #d32f2f)' : '#6b7280'};
`;

export const PaymentSection = styled.div`
  margin-bottom: 24px;
`;

export const PaymentOptions = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const PaymentOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  color: #1f2937;

  input[type="radio"] {
    width: 20px;
    height: 20px;
    accent-color: var(--primary, #f58220);
  }

  i {
    font-size: 1.1rem;
  }

  .icon-pix {
    color: #10b981;
  }

  .icon-card {
    color: #3b82f6;
  }

  .icon-cash {
    color: #fbbf24;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 24px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #f3f4f6;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 600;
  outline: none;
  transition: all 0.2s;
  margin-bottom: 12px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  &:focus {
    border-color: var(--primary, #f58220);
    box-shadow: 0 4px 12px rgba(245, 130, 32, 0.15);
  }

  &::placeholder {
    color: #9ca3af;
    font-weight: 500;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #f3f4f6;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 600;
  outline: none;
  transition: all 0.2s;
  margin-bottom: 12px;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  &:focus {
    border-color: var(--primary, #f58220);
    box-shadow: 0 4px 12px rgba(245, 130, 32, 0.15);
  }

  &::placeholder {
    color: #9ca3af;
    font-weight: 500;
  }
`;

export const CheckoutButton = styled.button`
  width: 100%;
  background: #10b981;
  color: white;
  font-weight: 900;
  font-size: 1.1rem;
  padding: 18px 32px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-transform: uppercase;
  margin-bottom: 24px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const KeepShoppingButton = styled.button`
  width: 100%;
  background: #f3f4f6;
  color: #4b5563;
  font-weight: 800;
  font-size: 0.95rem;
  padding: 16px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-transform: uppercase;
  margin-bottom: 24px;

  &:hover {
    background: #e5e7eb;
    color: #1f2937;
  }
`;

export const WhatsAppIcon = styled.span`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PixContainer = styled.div`
  background: #f0fdf4;
  border: 2px dashed #10b981;
  border-radius: 16px;
  padding: 16px;
  margin-top: 12px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PixTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 900;
  color: #166534;
  text-transform: uppercase;
`;

export const PixKeyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #86efac;
`;

export const PixKey = styled.span`
  flex: 1;
  font-family: monospace;
  font-weight: 700;
  color: #166534;
  font-size: 0.85rem;
  word-break: break-all;
`;

export const CopyButton = styled.button`
  background: #10b981;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #059669;
  }

  &:active {
    transform: scale(0.95);
  }
`;
